import classes from "../../styles/NewArticle.module.scss"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import ArticleForm from "../../components/Knowladge/ArticleForm"
import { editArticle, getArticleById } from "../../utils/requests/knowladgebase"

const EditArticle = () => {
  const [loading, setLoading] = useState(false)

  const [article, setArticle] = useState<Partial<KnowladgebaseArticle>>({})

  const { id } = useParams()

  useEffect(() => {
    if (!id) {
      return
    }

    const fetchArticle = async () => {
      const article = await getArticleById(id)
      setArticle(article)
    }
    fetchArticle()
  }, [id])

  const onSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    await editArticle(article)

    setLoading(false)
  }

  return (
    <div className={classes.root}>
      <ArticleForm
        formTitle="עריכת מאמר"
        values={article}
        onSubmit={onSubmit}
        onChange={setArticle}
        loading={loading}
        ctaLabel="שמירה"
      />
    </div>
  )
}

export default EditArticle
